import { websiteHost } from '@/config/host'
import { language } from '@/common/storage'

/** 根据当前平台语言，返回对应的官网域名 */
export function getOfficialSiteDomainByLang(): string {
  const lang = language.get({ reality: true })
  console.log('lang', lang, websiteHost)
  switch (lang) {
    case 'zh-cn':
      return `${websiteHost}/cn`
    // return `${websiteHost}`
    case 'ja':
      return `${websiteHost}/jp`
    default:
      return websiteHost
  }
}
